import React from 'react'
import { FieldArray, useField } from 'formik'
import options from 'components/Order/orderOptionalFeatures.json'
import { useTranslation } from 'react-i18next'
import styles from './CargoOptionalFeatures.module.css'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'

export function CargoOptionalFeaturesForm ({ name, disabled }) {
  const { t } = useTranslation()
  const [, meta] = useField(name)
  const { value } = meta

  return (
    <div>
      <FieldArray
        name={name}
        render={arrayHelpers => (
          <div className={styles.container}>
            <h2>{t('order.details.deliveryPoint.cargo.optionalFeatures.title')}</h2>
            {options.map(option => (
              <div key={option.id} className={styles.checkBoxContainer}>
                <label>
                  <PrimaryCheckbox
                    name={name}
                    type="checkbox"
                    value={option.id}
                    disabled={disabled}
                    checked={value.includes(option.id)}
                    onChange={e => {
                      if (e.target.checked) arrayHelpers.push(option.id)
                      else {
                        const idx = value.indexOf(option.id)
                        arrayHelpers.remove(idx)
                      }
                    }}
                  />
                  {' ' + t(`form.order.cargo.${option.label}`)}
                </label>
              </div>
            ))}
          </div>
        )}
      />
    </div>
  )
}

